import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TooltipDirective } from 'src/app/shared/ui/tooltip/tooltip.component';

@Component({
    selector: 'tab-stepper-container',
    templateUrl: './tab-container.component.html',
    styleUrls: ['./tab-container.component.scss'],
    imports: [CdkStepperModule, CommonModule, TooltipDirective],
    providers: [{ provide: CdkStepper, useExisting: TabStepperComponent }]
})
export class TabStepperComponent extends CdkStepper {
  selectStepByIndex(index: number): void {
    this.selectedIndex = index;
  }
}
